// components/SanitizationWarningDialog.jsx
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Chip,
    IconButton,
    Button,
    Divider,
    Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

export default function SanitizationWarningDialog({
    open,
    onClose,
    foundChars = [],
    foundPatterns = [],         // optional: pattern IDs from the sanitizer
    foundTerms = [],    // NEW
    title = "Unsafe Input Detected",
    message = "Please make sure your text does not contain the following:",
    actionLabel = "OK",
}) {
    // Dedupe & sort for consistent display
    const chars = Array.from(new Set(foundChars));
    const patterns = Array.from(new Set(foundPatterns));
    const terms = Array.from(new Set(foundTerms)); // NEW
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: (theme) => `0 10px 30px ${theme.palette.mode === "dark" ? "rgba(0,0,0,0.7)" : "rgba(0,0,0,0.15)"}`
                }
            }}
        >
            <Box
                sx={(theme) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 2.5,
                    py: 1.75,
                    bgcolor: theme.palette.error.main,
                    color: theme.palette.error.contrastText
                })}
            >
                <ReportGmailerrorredIcon />
                <DialogTitle sx={{ p: 0, flex: 1, fontWeight: 700 }}>{title}</DialogTitle>
                <IconButton onClick={onClose} sx={{ color: "inherit" }} aria-label="Close">
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent sx={{ pt: 2.5 }}>
                <Typography variant="body1" sx={{ mb: 1.5 }}>
                    {message}
                </Typography>

                {/* Forbidden Characters */}
                <Box sx={{ mb: 2 }}>
                    <Typography variant="overline" sx={{ opacity: 0.8 }}>
                        Forbidden characters
                    </Typography>
                    <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {chars.length ? (
                            chars.map((c, idx) => (
                                <Chip
                                    key={`${c}-${idx}`}
                                    label={c === " " ? "(space)" : c}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        fontWeight: 700,
                                        borderStyle: "dashed",
                                    }}
                                />
                            ))
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                None detected
                            </Typography>
                        )}
                    </Box>
                </Box>

                {/* NEW: Forbidden Terms */}
                {terms.length > 0 && (
                    <Box sx={{ mb: 1 }}>
                        <Typography variant="overline" sx={{ opacity: 0.8 }}>
                            Forbidden terms
                        </Typography>
                        <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {terms.map((t, idx) => (
                                <Chip key={`${t}-${idx}`} label={t} size="small" />
                            ))}
                        </Box>
                    </Box>
                )}

            </DialogContent>

            <DialogActions sx={{ px: 2.5, pb: 2.5 }}>
                <Button onClick={onClose} variant="contained" color="primary">
                    {actionLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
